'server-only';;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:native-teams-frontend":true});}catch(e){}}();

import { ACCESSIBLE_APPS, rolesIncludeContractor } from '@workspace/ui/lib';
import type { JwtPayload } from '@workspace/ui/types';
import { jwtDecode } from 'jwt-decode';

/**
 * Server-side check if user is an employee
 */
export const isEmployeeServer = async (): Promise<boolean> => {
  try {
    const { cookies } = await import('next/headers');
    const cookieStore = await cookies();
    const accessToken = cookieStore.get('access_token')?.value;

    if (!accessToken) {
      return false;
    }

    const decodedToken = jwtDecode<JwtPayload>(accessToken);
    return (
      decodedToken.accessible_app === ACCESSIBLE_APPS.EMPLOYEE &&
      !rolesIncludeContractor(decodedToken.roles)
    );
  } catch (error) {
    console.warn('Error checking employee status:', error);
    return false;
  }
};

/**
 * Server-side check if user is an employer
 */
export const isEmployerServer = async (): Promise<boolean> => {
  try {
    const { cookies } = await import('next/headers');
    const cookieStore = await cookies();
    const accessToken = cookieStore.get('access_token')?.value;

    if (!accessToken) {
      return false;
    }

    const decodedToken = jwtDecode<JwtPayload>(accessToken);
    return decodedToken.accessible_app === ACCESSIBLE_APPS.EMPLOYER;
  } catch (error) {
    console.warn('Error checking employer status:', error);
    return false;
  }
};

/**
 * Server-side check if user is a contractor
 */
export const isContractorServer = async (): Promise<boolean> => {
  try {
    const { cookies } = await import('next/headers');
    const cookieStore = await cookies();
    const accessToken = cookieStore.get('access_token')?.value;

    if (!accessToken) {
      return false;
    }

    const decodedToken = jwtDecode<JwtPayload>(accessToken);
    return (
      decodedToken.accessible_app === ACCESSIBLE_APPS.CONTRACTOR ||
      rolesIncludeContractor(decodedToken.roles)
    );
  } catch (error) {
    console.warn('Error checking contractor status:', error);
    return false;
  }
};

export const isIndividualCraftServer = async (): Promise<boolean> => {
  try {
    const { cookies } = await import('next/headers');
    const cookieStore = await cookies();
    const accessToken = cookieStore.get('access_token')?.value;

    if (!accessToken) {
      return false;
    }

    const decodedToken = jwtDecode<JwtPayload>(accessToken);
    return decodedToken.accessible_app === ACCESSIBLE_APPS.INDIVIDUAL_CRAFT;
  } catch (error) {
    console.warn('Error checking individual craft status:', error);
    return false;
  }
};
